export default {
  name: "SummaryLine",
  props: ["chartData", "hidePercentage", "noDataText"],
  computed: {
    noData() {
      return (
        this.chartData &&
        this.chartData.map(d => d.data).reduce((a, b) => a + b, 0) === 0
      );
    }
  },
  methods: {
    shouldShowPercentage() {
      // Margin for checking the text in the container
      const margin = 16;

      if (this.$refs.blocks) {
        this.$refs.blocks.forEach(obj => {
          // Magic ->
          // Checking if the container of the paragraph has lesser width
          // then the paragraph and a margin itself
          const isTheParagraphThickerThanContainer =
            obj && obj.children[0].clientWidth + margin > obj.clientWidth;
  
          if (isTheParagraphThickerThanContainer) {
            obj.classList.remove("visible");
          } else {
            obj.classList.add("visible");
          }
        });
      }
    }
  },
  mounted() {
    if (!this.hidePercentage) {
      window.addEventListener("resize", this.shouldShowPercentage);
    }
  },
  updated() {
    if (!this.hidePercentage) {
      this.shouldShowPercentage();
    }
  },
  destroyed() {
    if (!this.hidePercentage) {
      window.removeEventListener("resize", this.shouldShowPercentage);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/_charts/chart-types/summary-line/summary-line.js